// extracted by mini-css-extract-plugin
export var avatarContainer = "_dg-0";
export var avatarTypingWave = "_dg-i";
export var gray = "_dg-f";
export var green = "_dg-c";
export var icon = "_dg-9";
export var image = "_dg-1";
export var lg = "_dg-6";
export var md = "_dg-5";
export var presenceDot = "_dg-b";
export var red = "_dg-d";
export var sm = "_dg-4";
export var status = "_dg-a";
export var typingDot = "_dg-h";
export var typingPill = "_dg-g";
export var xl = "_dg-7";
export var xs = "_dg-3";
export var xxl = "_dg-8";
export var xxs = "_dg-2";
export var yellow = "_dg-e";